import * as React from 'react';
import clsx from 'clsx';
import styles from './SizeSelector.module.scss';
import { SizeSelectorProps } from './types';

export function SizeSelector({ label = '', selected = false, onClick }: SizeSelectorProps) {
  return (
    <button
      className={clsx(styles.sizeButton, {
        [styles.selected]: selected,
      })}
      onClick={() => onClick(!selected)}
      role="radio"
      aria-checked={selected}
    >
      <span className={styles.sizeText}>{label}</span>
    </button>
  );
}
